import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import casual from './assets/casual.jpg';

function About() {
  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <Navbar />
      <main className="flex-grow text-white flex pt-20">
        <div className="flex gap-12 w-full">
          <div className="flex-1">
            <p className="mb-4 text-sm">Howdy! My name is Aarya Patel.</p>
            <p className="mb-4 text-sm">I'm currently a Senior at Texas A&M studying Computer Engineering.</p>
            
            <div className="mb-4">
              <h3 className="text-base font-semibold mb-2">Experience</h3>
              <ul className="list-disc list-inside space-y-2 text-sm pl-0">
                <li>Software Engineer Intern @ <a href="https://www.oracle.com/cloud/">Oracle</a> (2026)</li>
                <li>Software Engineer Intern @ <a href="https://www.heb.com/">H-E-B</a> (2025)</li>
                <li>Security Engineer Intern @ <a href="https://www.heb.com/">H-E-B</a> (2024)</li>
                <li>Software Engineer for <a href="https://cansatcompetition.com/">CanSat</a> (2025)</li>
                <li>Coding Instructor @ <a href="https://icodeschool.com/plano109/">iCode</a> (2023)</li>
              </ul>
            </div>

            <div className="mb-4">
              <h3 className="text-base font-semibold mb-2">Leadership</h3>
              <ul className="list-disc list-inside space-y-2 text-sm pl-0">
                <li>President @ <a href="https://www.aggiecodingclub.com/">Aggie Coding Club</a></li>
                <li>President @ <a href="https://tacs.tamu.edu/">Texas A&M Computing Society</a></li>
                <li>TA for <a href="https://engineering.tamu.edu/electrical/index.html">ECEN 215</a></li>
                <li>Volunteer @ <a href="https://12thcan.tamu.edu/">12th Can</a></li>
              </ul>
            </div>

            <div className="mb-4">
              <h3 className="text-base font-semibold mb-2">Awards</h3>
              <ul className="list-disc list-inside space-y-2 text-sm pl-0">
                <li><a href="https://tamupkp.wordpress.com/2024/10/07/2024-gathright-deans-excellence-award-winners/">Freshman Gathright Scholar</a></li>
                <li><a href="https://brownfound.org/">Brown Scholar (full-ride)</a></li>
                <li><a href="https://engineering.tamu.edu/news/2024/05/students-participate-in-nasas-annual-mittic-competition.html">Finalist for NASA Space2Pitch</a></li>
              </ul>
            </div>
          </div>
          <div className="flex-shrink-0 flex flex-col pr-0">
            <img src={casual} alt="Aarya" className="w-72 h-72 rounded-full object-cover mb-6 self-end" />
            <div className="text-left ml-[15%]">
              <p className="mb-2 text-sm">My Favorites:</p>
              <ul className="list-disc list-inside space-y-2 text-sm">
                <li><a href="https://leetcode.com/problems/climbing-stairs/">Favorite LeetCode Problem</a></li>
                <li><a href="https://play.usatoday.com/crossword">USA Today Crossword</a></li>
                <li><a href="https://sudoku.com/">Sudoku.com</a></li>
                <li><a href="https://youtu.be/GB3zR_X25UU?si=2FobtDfq5vWJB_Xa">Favorite Study Music</a></li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default About;